module.exports = __webpack_public_path__ + "img/img24.87a420ab.svg";